import Img from 'gatsby-image'
import PropTypes from 'prop-types'
import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { CarouselWrapper } from './styles'

const ImageCarousel = ({ images, infiniteLoop = true }) => {
  return (
    <CarouselWrapper>
      <Carousel
        showIndicators={images.length > 1}
        showStatus={false}
        showArrows={false}
        showThumbs={false}
        autoPlay={false}
        infiniteLoop={infiniteLoop && images.length > 1}
      >
        {images.map((image, index) => (
          <Img key={index} alt={image.title} fluid={image.fluid} />
        ))}
      </Carousel>
    </CarouselWrapper>
  )
}

ImageCarousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  infiniteLoop: PropTypes.bool
}

export default ImageCarousel
